import styles from "./PropertyInfoTags.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import BedIcon from "@Icons/BedIcon";
import StaresIcon from "@Icons/StaresIcon";
import BuildingIcon from "@Icons/BuildingIcon";
import useTranslationHook from "hooks/useTranslationHook";

const PropertyInfoTag = ({ type, value }: any) => {
  const { t } = useTranslationHook();
  if (value <= 0) return null;

  const getIconBasedOnNameType = (nameType: string) => {
    switch (nameType) {
      case "total_units":
        return <BedIcon />;
      case "highest_floor":
        return <StaresIcon />;
      case "build_in_year":
        return <BuildingIcon />;
      default:
        return <BuildingIcon />;
    }
  };

  const getNameBasedOnNameTypeAndValue = (nameType: string, myValue: number) => {
    switch (nameType) {
      case "total_units":
        return `${myValue} ${t("Total Units")}`;
      case "highest_floor":
        return `${t("Highest Floor")} ${myValue}`;
      case "build_in_year":
        return `${t("Built in")} ${myValue}`;
      default:
        return null;
    }
  };

  return (
    <>
      <div className={formatClassNames(styles.parentContainer)}>
        <div className={styles.journeyContainer} data-testid="property-info-tags">
          <div className={styles.iconContainer}>{getIconBasedOnNameType(type)}</div>
          <div data-testid="property-info-tags" className={styles.info}>
            <div className={styles.cityName}>{getNameBasedOnNameTypeAndValue(type, value)}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(PropertyInfoTag, {
  componentName: "PropertyInfoTag-PropertyDetailsSection-PropertyPage",
  showForChina: true,
});
